<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	// Stores
	import { user_data, user_settings } from 'src/stores/account/user';
	// Design system components
	import { Container, Text, Stack, Collapse, Alert } from '@Shelly/shelly-design-system';
	//Helpers
	import { powerPricesToIntervals } from '../helpers/power_prices_helpers';
	//App Components
	import PreferredCurrency from '../components/Settings/PowerPricesSettings/PreferredCurrency.svelte';
	import BillingDate from '../components/Settings/PowerPricesSettings/BillingDate.svelte';
	import Tariffs from '../components/Settings/PowerPricesSettings/Tariffs.svelte';
	import Intervals from '../components/Settings/PowerPricesSettings/Intervals.svelte';
	import TimeZone from '../components/Settings/AccountSettings/Localization/TimeZone.svelte';
	import PeakPower from 'src/components/Settings/PowerPricesSettings/PeakPower.svelte';

	import { isDevServerUser } from 'src/helpers/user_server_conditions';

	const powerPriceMenus = [
		{
			title: $format('title_electricity_tariff_details', {
				default: 'Electricity Tariff Details',
			}),
			notification: {
				heading: $format('set_electricity_tariff_details', {
					default: 'Set details',
				}),
				message: $format('info_msg_electricity_tarrif', {
					default:
						'Currently you don’t have any information set  in Electricity Tariff. Set your billing date and preferred currency and get the benefit of monitoring your electricity value.',
				}),
			},
			collapseComponents: [
				{
					title: $format('title_billing_date', { default: 'Billing Date' }),
					component: BillingDate,
					id: 'billDate',
					expanded: true,
				},
				{
					title: $format('title_preferred_currency', {
						default: 'Preferred Currency',
					}),
					component: PreferredCurrency,
					id: 'prefCurr',
					expanded: true,
				},
			],
		},
	];

	$: powerPrices = powerPricesToIntervals(
		$user_settings.power_prices
			? JSON.parse($user_settings.power_prices)
			: { tariffs: {}, schedule: [], intervals: {} },
	);

	$: currency = $user_settings.currency || '';

	$: disableTariffs = $user_settings.hasOwnProperty('power_prices_live_tariff');

	$: liveTariffEnabled = typeof $user_settings?.power_prices_live_tariff !== 'undefined';
</script>

{#each powerPriceMenus as menu}
	<Container class="mb-s">
		<Text element="h2" class="mb-s">
			{menu.title}
		</Text>
		{#if menu.notification && !currency}
			<Alert
				class="mb-s"
				type="info"
				heading={menu.notification.heading}
				message={menu.notification.message}
			/>
		{/if}
		{#if menu.collapseComponents}
			<Stack gap="s">
				{#each menu.collapseComponents as item}
					<Collapse
						id="collapse-2itkqp7"
						title={item.title}
						expanded={item.expanded}
						on:click={() => {
							item.expanded = !item.expanded;
						}}
					>
						<svelte:component this={item.component} />
					</Collapse>
				{/each}
			</Stack>
		{/if}
	</Container>
{/each}

{#if isDevServerUser(['repo', 't1', 'nb'])}
	<PeakPower />
{/if}

{#if powerPrices}
	<Container class="mb-s">
		<Tariffs bind:powerPrices {currency} {disableTariffs} />
	</Container>
	{#if Object.keys(powerPrices.tariffs).length > 0}
		<Container class="mb-s">
			<div class=" d-flex align-items-center mb-m">
				<Text class="mb-xs" element="h2"
					>{$format('text_title_live_tariff_timezone', {
						default: `Timezone`,
					})}</Text
				>
			</div>
			<TimeZone />
		</Container>
	{/if}
	{#if !liveTariffEnabled}
		<Container class="mb-s">
			<Intervals bind:powerPrices bind:liveTariffEnabled {currency} />
		</Container>
	{/if}
{/if}
